import { motion } from "framer-motion";
import { WorkspaceAnalytics } from "@/types/workspace";
import { TotalRCVCard } from "./TotalRCVCard";
import { MoneyFoundCard } from "./MoneyFoundCard";
import { TimeSavedCard } from "./TimeSavedCard";

interface MetricsCardsProps {
    analytics: WorkspaceAnalytics;
}

export function MetricsCards({ analytics }: MetricsCardsProps) {
    if (analytics.comparisonsCount === 0) return null;

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 mb-8">
            {/* Total RCV */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="h-full"
            >
                <TotalRCVCard analytics={analytics} />
            </motion.div>

            {/* Money Found */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="h-full"
            >
                <MoneyFoundCard analytics={analytics} />
            </motion.div>

            {/* Time Saved */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="h-full"
            >
                <TimeSavedCard analytics={analytics} />
            </motion.div>
        </div>
    );
}
